import api from './api';

export const getChannels = async (params = {}) => {
  const response = await api.get('/channels/', { params });
  return response.data;
};

export const getChannel = async (id) => {
  const response = await api.get(`/channels/${id}`);
  return response.data;
};

export const createChannel = async (channelData) => {
  const response = await api.post('/channels/', channelData);
  return response.data;
};

export const updateChannel = async (id, channelData) => {
  const response = await api.put(`/channels/${id}`, channelData);
  return response.data;
};

export const deleteChannel = async (id) => {
  const response = await api.delete(`/channels/${id}`);
  return response.data;
};

export const bindTokenToChannel = async (channelId, tokenId, priority = 10) => {
  const response = await api.post(`/channels/${channelId}/bind/${tokenId}`, { priority });
  return response.data;
};

export const unbindTokenFromChannel = async (channelId, tokenId) => {
  const response = await api.delete(`/channels/${channelId}/bind/${tokenId}`);
  return response.data;
};

export const autoBindTokenToChannel = async (channelId, priority = 10) => {
  const response = await api.post(`/channels/${channelId}/auto-bind`, { priority });
  return response.data;
};

export const getChannelWithBindings = async (channelId) => {
  const response = await api.get(`/channels/${channelId}?include_bindings=true`);
  return response.data;
};

export const getChannelBindings = async (channelId) => {
  const response = await api.get(`/channels/${channelId}/bindings`);
  return response.data;
};